var path = '/pages/dashboard/directives/dashboard-barchart-simple-directive.tpl.html';
var html = "<canvas class=\"chart chart-bar\" chart-data=\"ctrl.data\" chart-series=\"ctrl.series\" chart-labels=\"ctrl.labels\"></canvas>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/dashboard/directives/dashboard-barchart-simple-directive.tpl.html
// module id = 2237
// module chunks = 1